// La papelera del registro de terreno sobre TanStack Query.
//
// La key de la papelera cuelga de la del registro (`["informes","terreno",id]`):
// una sola invalidación refresca el registro Y la papelera, que es lo que
// necesita todo acto de acá (el bloque cambia de lista).

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  descartarRegistroDeTerreno,
  fetchPapeleraDeTerreno,
  restaurarRegistroDeTerreno,
  vaciarPapeleraDeTerreno,
} from "@/lib/terreno";

import { registroDeTerrenoKey } from "./useRegistroDeTerreno";

export const papeleraDeTerrenoKey = (informeId: number) =>
  [...registroDeTerrenoKey(informeId), "papelera"] as const;

export function usePapeleraDeTerreno(informeId: number | null) {
  return useQuery({
    queryKey: papeleraDeTerrenoKey(informeId ?? 0),
    queryFn: () => fetchPapeleraDeTerreno(informeId as number),
    enabled: informeId !== null,
  });
}

function useRefrescarElTerreno(informeId: number) {
  const cliente = useQueryClient();

  return () => cliente.invalidateQueries({ queryKey: registroDeTerrenoKey(informeId) });
}

export function useDescartarRegistroDeTerreno(informeId: number) {
  const refrescar = useRefrescarElTerreno(informeId);

  return useMutation({
    mutationFn: (uuid: string) => descartarRegistroDeTerreno(informeId, uuid),
    onSuccess: refrescar,
  });
}

export function useRestaurarRegistroDeTerreno(informeId: number) {
  const refrescar = useRefrescarElTerreno(informeId);

  return useMutation({
    mutationFn: (uuid: string) => restaurarRegistroDeTerreno(informeId, uuid),
    onSuccess: refrescar,
  });
}

export function useVaciarPapeleraDeTerreno(informeId: number) {
  const refrescar = useRefrescarElTerreno(informeId);

  return useMutation({
    mutationFn: () => vaciarPapeleraDeTerreno(informeId),
    onSuccess: refrescar,
  });
}
